export default "__VITE_ASSET__OcpErZRq__"